import React from "react";

export default (props) => {
  return (
    <div>
      <label className="text-gray-500">{props.label}  {props.required ? <i className="star ">*</i> : ''}</label>
      <textarea
      className="w-full border border-slate-200 px-2 py-3 rounded-md text-right"
        placeholder={props.placeholder ? props.placeholder : ""}
        defaultValue={props.value}
        style={props.style}
        name={props.name}
        rows="3"
      />
    </div>
  );
};
